"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ACWrapperContext_1 = require("./ACWrapperContext");
var ACImage = function (props) {
    var CONSTANTS = (0, ACWrapperContext_1.getCONSTANTS)();
    var imgUrl = "".concat(CONSTANTS.AUTH_BASE_URL, "/api/").concat(props.img);
    return ((0, jsx_runtime_1.jsx)("img", { className: props.imgClassName, src: imgUrl, alt: props.name, onClick: props.onClick }));
};
exports.ACImage = ACImage;
